/**
 * WMS Putaway Task Types
 * Shared between backend-wms and mobile-app
 *
 * DRY Compliance: Single source for all putaway task enums
 */

/**
 * Status of a putaway task
 */
export enum PutawayTaskStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

/**
 * Priority level for putaway tasks
 */
export enum PutawayTaskPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  URGENT = 'URGENT',
}

/**
 * Status labels for UI display
 */
export const PutawayTaskStatusLabels: Record<PutawayTaskStatus, string> = {
  [PutawayTaskStatus.PENDING]: 'Pending',
  [PutawayTaskStatus.IN_PROGRESS]: 'In Progress',
  [PutawayTaskStatus.COMPLETED]: 'Completed',
  [PutawayTaskStatus.CANCELLED]: 'Cancelled',
};

export const PutawayTaskPriorityLabels: Record<PutawayTaskPriority, string> = {
  [PutawayTaskPriority.LOW]: 'Low',
  [PutawayTaskPriority.MEDIUM]: 'Medium',
  [PutawayTaskPriority.HIGH]: 'High',
  [PutawayTaskPriority.URGENT]: 'Urgent',
};

/**
 * Color schemes for status/priority badges (Chakra UI v3 compatible)
 */
export const PutawayTaskStatusColors: Record<PutawayTaskStatus, string> = {
  [PutawayTaskStatus.PENDING]: 'gray',
  [PutawayTaskStatus.IN_PROGRESS]: 'blue',
  [PutawayTaskStatus.COMPLETED]: 'green',
  [PutawayTaskStatus.CANCELLED]: 'red',
};

export const PutawayTaskPriorityColors: Record<PutawayTaskPriority, string> = {
  [PutawayTaskPriority.LOW]: 'gray',
  [PutawayTaskPriority.MEDIUM]: 'blue',
  [PutawayTaskPriority.HIGH]: 'orange',
  [PutawayTaskPriority.URGENT]: 'red',
};
